import { Group, SegmentedControl } from '@mantine/core';
import { IconCreditCard, IconCreditCardPay } from '@tabler/icons-react';
import { useUnit } from 'effector-react';
import { useNavigate } from 'react-router';
import { $mode, type Mode, setMode } from '~/shared/store/mode';

export const ModeSwitcher = () => {
    const mode = useUnit($mode);

    const navigate = useNavigate();

    return (
        <SegmentedControl
            size='sm'
            p={0}
            value={mode}
            onChange={(mode) => {
                setMode(mode as Mode);
                navigate(`/${mode}`);
            }}
            color='brand'
            data={[
                {
                    value: 'payout',
                    label: (
                        <Group
                            gap={4}
                            wrap='nowrap'
                        >
                            <IconCreditCardPay size={16} />

                            <span>Выплаты</span>
                        </Group>
                    ),
                },
                {
                    value: 'payin',
                    label: (
                        <Group
                            gap={4}
                            wrap='nowrap'
                        >
                            <IconCreditCard size={16} />

                            <span>Прием</span>
                        </Group>
                    ),
                },
            ]}
        />
    );
};
